import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { ref } from "vue";
import { logException } from "@sazka/utils/logger/use-app-logger";

interface Numbers {
    primaryNumbers: number[];
    secondaryNumbers: number[];
}

interface NumbersStatistics {
    mostFrequentNumbers: Numbers;
    leastFrequentNumbers: Numbers;
    evenOddProportions: number[];
    lowHighProportions: number[];
}

const mostFrequentNumbers = ref<Numbers>();
const leastFrequentNumbers = ref<Numbers>();
const evenOdd = ref<number[]>(null);
const lowHigh = ref<number[]>(null);
const resolvedResponse = ref<Promise<NumbersStatistics> | null>(null);

export function useDrawNumbersStatistics(lottery: Lottery) {
    async function getStatistics() {
        if (!resolvedResponse.value) {
            resolvedResponse.value = loadStatistics();
        }

        const numbers = await resolvedResponse.value;

        mostFrequentNumbers.value = numbers.mostFrequentNumbers;
        leastFrequentNumbers.value = numbers.leastFrequentNumbers;
    }

    async function getAdditionalStatistics() {
        if (!resolvedResponse.value) {
            resolvedResponse.value = loadStatistics();
        }

        const numbers = await resolvedResponse.value;

        evenOdd.value = numbers.evenOddProportions;
        lowHigh.value = numbers.lowHighProportions;
    }

    async function loadStatistics(): Promise<NumbersStatistics> {
        try {
            const response = await httpClient.get<NumbersStatistics>(`/api/draw-info/statistics/${lottery}`);
            return response?.data;
        } catch (err) {
            logException("draw-numbers-statistics", err);
        }
    }

    return {
        mostFrequentNumbers,
        leastFrequentNumbers,
        evenOdd,
        lowHigh,
        loadStatistics,
        getStatistics,
        getAdditionalStatistics,
    };
}
